import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "day-preview-card",
  class: "bg-white rounded-2xl border-2 border-active/40 p-4 sm:p-6 shadow-md space-y-4"
}
const _hoisted_2 = { class: "flex flex-col sm:flex-row sm:items-center justify-between gap-3 pb-4 border-b border-divider" }
const _hoisted_3 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_4 = { class: "text-lg sm:text-xl font-bold text-brown mt-1 flex flex-wrap items-center gap-2" }
const _hoisted_5 = { class: "font-caudex text-active" }
const _hoisted_6 = { class: "flex items-center gap-2" }
const _hoisted_7 = { class: "grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-4 text-xs" }
const _hoisted_8 = { class: "p-3.5 rounded-xl bg-secondary border border-divider space-y-1.5" }
const _hoisted_9 = { class: "font-bold text-muted uppercase text-[10px]" }
const _hoisted_10 = { class: "font-bold text-brown text-sm" }
const _hoisted_11 = { class: "text-alternative-gray" }
const _hoisted_12 = { class: "p-3.5 rounded-xl bg-secondary border border-divider space-y-1.5" }
const _hoisted_13 = { class: "font-bold text-muted uppercase text-[10px]" }
const _hoisted_14 = { class: "font-bold text-brown text-sm" }
const _hoisted_15 = { class: "p-3.5 rounded-xl bg-beige border border-divider space-y-1.5" }
const _hoisted_16 = { class: "font-bold text-active uppercase text-[10px]" }
const _hoisted_17 = { class: "text-brown font-semibold" }
const _hoisted_18 = {
  key: 0,
  class: "text-error font-semibold"
}
const _hoisted_19 = { class: "text-alternative-gray pt-1" }
const _hoisted_20 = { class: "text-brown" }

import { computed } from "vue";
import { MonthDayReport } from "@/types/calculators";
import { useI18n } from "vue-i18n";
import { formatDate } from "@/utils/date";
import { useLangStore } from "@/stores/langStore";
import { BADGE_TIER_CLASSES } from "@/constants/tongShu";


export default /*@__PURE__*/_defineComponent({
  __name: 'DayReportPreviewComponent',
  props: {
    selectedCard: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const langStore = useLangStore();

const doings = computed(() => {
  const res = [];
  const status = props.selectedCard.personal_status;

  const goodContent = status.structures[0] || status.stars[0];
  const warningContent = status.warnings[0];

  if (goodContent) {
    res.push({
      content: `✓ ${goodContent}`,
      classes: "text-success font-semibold",
    });
  }

  if (warningContent) {
    res.push({
      content: `✕ ${warningContent}`,
      classes: "text-error font-semibold",
    });
  }
  if (res.length > 0) {
    return res;
  }

  return [
    {
      content: t(
        "calculators.personal-date.personal_compatibility.influence_neutral"
      ),
      classes: "text-alternative-gray",
    },
  ];
});

const yiDoings = computed(() => {
  const items = props.selectedCard.yi_preview || [];

  if (items.length === 0) return "";

  const list = items.map((item) => `${item.name} (${item.ua})`).join(", ");

  return `宜: ${list}`;
});

const formattedHours = computed(() => {
  const hours = props.selectedCard.best_hours || [];

  return hours
    .map((h) => `${h.branch}时 ${formatHourRange(h.time_std)}`)
    .join(", ");
});

function formatHourRange(rangeStr: string): string {
  if (!rangeStr) return "";

  const startTime = rangeStr.split("-")[0].trim();
  return `(${startTime})`;
}

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", {
            class: _normalizeClass(["px-2.5 py-0.5 rounded-full text-xs font-bold", _unref(BADGE_TIER_CLASSES)[__props.selectedCard.tier]])
          }, _toDisplayString(_unref(t)(`calculators.personal-date.card-barge.${__props.selectedCard.tier}`)), 3),
          _createVNode(_component_i18n_t, {
            keypath: "calculators.personal-date.day-index",
            tag: "span",
            class: "text-xs text-muted"
          }, {
            score: _withCtx(() => [
              _createElementVNode("strong", null, _toDisplayString(__props.selectedCard.combined_index) + " / 100", 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("h3", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_unref(formatDate)(__props.selectedCard.date, _unref(langStore).current)), 1),
          _createElementVNode("span", _hoisted_5, " (" + _toDisplayString(__props.selectedCard.pillars.year) + " • " + _toDisplayString(__props.selectedCard.pillars.month) + " • " + _toDisplayString(__props.selectedCard.pillars.day) + ") ", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "w-full sm:w-auto px-5 py-2.5 rounded-xl bg-active text-white text-xs sm:text-sm font-bold hover:bg-active-dark transition-colors shadow-sm flex items-center justify-center gap-2",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('openFullReport')))
        }, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.personal-date.tong_shu.show-full-report")), 1),
          _cache[1] || (_cache[1] = _createElementVNode("span", null, "→", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)("calculators.personal-date.tong_shu.title")), 1),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)("calculators.personal-date.tong_shu.ruler", {
              name: `${__props.selectedCard.officer_12.name} (${__props.selectedCard.officer_12.title_ua})`,
              rank: __props.selectedCard.general_status.rank_code,
            })), 1),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_i18n_t, {
            keypath: "calculators.personal-date.tong_shu.yin_day_element",
            tag: "span"
          }, {
            element: _withCtx(() => [
              _createElementVNode("strong", null, _toDisplayString(__props.selectedCard.day_na_yin), 1)
            ]),
            _: 1
          }),
          _cache[2] || (_cache[2] = _createTextVNode(" • ", -1)),
          _createVNode(_component_i18n_t, {
            keypath: "calculators.personal-date.tong_shu.peng_zu",
            tag: "span"
          }, {
            text: _withCtx(() => [
              _createElementVNode("strong", null, _toDisplayString(__props.selectedCard.peng_zu), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)("calculators.personal-date.personal_compatibility.title")), 1),
        _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)("calculators.personal-date.personal_compatibility.scoring", {
              percent: __props.selectedCard.personal_status.score,
              gods: `${__props.selectedCard.personal_status.ten_god_stem} / ${__props.selectedCard.personal_status.ten_god_branch}`,
            })), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(doings.value, (doing, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(doing.classes)
          }, _toDisplayString(doing.content), 3))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)("calculators.personal-date.favorable_block.title")), 1),
        _createElementVNode("div", _hoisted_17, _toDisplayString(yiDoings.value), 1),
        (yiDoings.value === '' && __props.selectedCard.ji_preview.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(__props.selectedCard.ji_preview[0].name) + " - " + _toDisplayString(__props.selectedCard.ji_preview[0].ua), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _createTextVNode(_toDisplayString(_unref(t)("calculators.personal-date.favorable_block.best_hours_label")) + " ", 1),
          _createElementVNode("strong", _hoisted_20, _toDisplayString(formattedHours.value), 1)
        ])
      ])
    ])
  ]))
}
}

})